import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import * as Modal from "@radix-ui/react-dialog";
import { Home, ClipboardList, Menu } from "lucide-react";

/** 手机导航复用 Layout 已过滤的菜单；只提供快捷入口，不另造角色权限规则。 */
export function MobileNavigation({ items, showTodos, todoCount = 0, zh, onMenu, menuOpen }) {
  return (
    <nav aria-label={zh ? "手机常用导航" : "Mobile navigation"} data-testid="mobile-bottom-nav"
      className="mobile-bottom-nav md:hidden fixed inset-x-0 bottom-0 z-30 border-t border-slate-200 bg-white/95 backdrop-blur-md flex items-stretch px-2">
      <NavLink to="/" end className={({ isActive }) => `mobile-nav-item ${isActive ? "is-active" : ""}`}>
        <Home aria-hidden="true" size={21} /><span>{zh ? "首页" : "Home"}</span>
      </NavLink>
      {showTodos && <NavLink to="/todos" className={({ isActive }) => `mobile-nav-item ${isActive ? "is-active" : ""}`}>
        <span className="relative"><ClipboardList aria-hidden="true" size={21} />{todoCount > 0 && <span aria-label={zh ? `${todoCount}项待办` : `${todoCount} to-dos`} className="absolute -right-3 -top-1 min-w-4 rounded-full bg-red-600 px-1 text-[10px] leading-4 text-white">{todoCount > 99 ? "99+" : todoCount}</span>}</span><span>{zh ? "待办" : "To-dos"}</span>
      </NavLink>}
      {items.map(({ to, icon: Icon, label }) => <NavLink key={to} to={to} className={({ isActive }) => `mobile-nav-item ${isActive ? "is-active" : ""}`}>
        <Icon aria-hidden="true" size={21} /><span>{label}</span>
      </NavLink>)}
      <button type="button" className={`mobile-nav-item ${menuOpen ? "is-active" : ""}`} onClick={onMenu}
        aria-expanded={menuOpen} aria-haspopup="dialog" data-testid="mobile-bottom-more">
        <Menu aria-hidden="true" size={21} /><span>{zh ? "更多" : "More"}</span>
      </button>
    </nav>
  );
}

/**
 * 原手机侧栏只是平移桌面 aside，背景仍可滚动、焦点还会落到隐藏菜单。
 * 小于桌面断点时交给 Radix 管理焦点、Escape 和滚动锁，桌面仍使用原 aside。
 * 页面内弹窗保持原有较高层级；关闭导航后将焦点交回真实触发按钮。
 */
export function ResponsiveSidebar({ open, onOpenChange, zh, children }) {
  const [compact, setCompact] = useState(() => typeof window !== "undefined" && window.matchMedia("(max-width: 1023px)").matches);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 1023px)");
    const change = () => { setCompact(mq.matches); if (!mq.matches) onOpenChange(false); };
    mq.addEventListener("change", change);
    return () => mq.removeEventListener("change", change);
  }, [onOpenChange]);
  if (!compact) return children;
  return <Modal.Root open={open} onOpenChange={onOpenChange}>
    <Modal.Portal>
      <Modal.Overlay className="fixed inset-0 z-[35] bg-slate-900/40 backdrop-blur-[2px]" data-testid="mobile-nav-backdrop" />
      <Modal.Content asChild aria-label={zh ? "全部功能" : "All features"} aria-describedby={undefined}
        onCloseAutoFocus={(event) => {
          event.preventDefault();
          const trigger = document.querySelector('[data-testid="mobile-bottom-more"]');
          const visibleTrigger = trigger?.getClientRects().length ? trigger : document.querySelector('[data-testid="mobile-nav-open"]');
          visibleTrigger?.focus();
        }}>
        {React.cloneElement(children, {}, <><Modal.Title className="sr-only">{zh ? "全部功能" : "All features"}</Modal.Title>{children.props.children}</>)}
      </Modal.Content>
    </Modal.Portal>
  </Modal.Root>;
}
